module.exports = __webpack_public_path__ + "img/code1.56d31813.jpg";